/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.24.2
// source: battery_heartbeat_service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as battery_heartbeat_service_pb from './battery_heartbeat_service_pb';


export class BatteryDataServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetBatteryHeartbeatByID = new grpcWeb.MethodDescriptor(
    '/api.BatteryDataService/GetBatteryHeartbeatByID',
    grpcWeb.MethodType.UNARY,
    battery_heartbeat_service_pb.GetBatteryHeartbeatByIDRequest,
    battery_heartbeat_service_pb.GetBatteryHeartbeatByIDResponse,
    (request: battery_heartbeat_service_pb.GetBatteryHeartbeatByIDRequest) => {
      return request.serializeBinary();
    },
    battery_heartbeat_service_pb.GetBatteryHeartbeatByIDResponse.deserializeBinary
  );

  getBatteryHeartbeatByID(
    request: battery_heartbeat_service_pb.GetBatteryHeartbeatByIDRequest,
    metadata: grpcWeb.Metadata | null): Promise<battery_heartbeat_service_pb.GetBatteryHeartbeatByIDResponse>;

  getBatteryHeartbeatByID(
    request: battery_heartbeat_service_pb.GetBatteryHeartbeatByIDRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: battery_heartbeat_service_pb.GetBatteryHeartbeatByIDResponse) => void): grpcWeb.ClientReadableStream<battery_heartbeat_service_pb.GetBatteryHeartbeatByIDResponse>;

  getBatteryHeartbeatByID(
    request: battery_heartbeat_service_pb.GetBatteryHeartbeatByIDRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: battery_heartbeat_service_pb.GetBatteryHeartbeatByIDResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.BatteryDataService/GetBatteryHeartbeatByID',
        request,
        metadata || {},
        this.methodDescriptorGetBatteryHeartbeatByID,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.BatteryDataService/GetBatteryHeartbeatByID',
    request,
    metadata || {},
    this.methodDescriptorGetBatteryHeartbeatByID);
  }

  methodDescriptorGetBatterySoH = new grpcWeb.MethodDescriptor(
    '/api.BatteryDataService/GetBatterySoH',
    grpcWeb.MethodType.UNARY,
    battery_heartbeat_service_pb.GetBatterySoHRequest,
    battery_heartbeat_service_pb.GetBatterySoHResponse,
    (request: battery_heartbeat_service_pb.GetBatterySoHRequest) => {
      return request.serializeBinary();
    },
    battery_heartbeat_service_pb.GetBatterySoHResponse.deserializeBinary
  );

  getBatterySoH(
    request: battery_heartbeat_service_pb.GetBatterySoHRequest,
    metadata: grpcWeb.Metadata | null): Promise<battery_heartbeat_service_pb.GetBatterySoHResponse>;

  getBatterySoH(
    request: battery_heartbeat_service_pb.GetBatterySoHRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: battery_heartbeat_service_pb.GetBatterySoHResponse) => void): grpcWeb.ClientReadableStream<battery_heartbeat_service_pb.GetBatterySoHResponse>;

  getBatterySoH(
    request: battery_heartbeat_service_pb.GetBatterySoHRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: battery_heartbeat_service_pb.GetBatterySoHResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.BatteryDataService/GetBatterySoH',
        request,
        metadata || {},
        this.methodDescriptorGetBatterySoH,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.BatteryDataService/GetBatterySoH',
    request,
    metadata || {},
    this.methodDescriptorGetBatterySoH);
  }

}

